// Estilos do painel de inspeção do nó selecionado
const styles = (theme) => ({
  // Painel de edição do elemento selecionado
  inspectorBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 1.5,
    borderRadius: 2,
    width: { xs: "min(320px, calc(100vw - 32px))", sm: 320 },
    maxHeight: { xs: "calc(100vh - 64px)", sm: 480 },
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  // Teto do painel bem mais alto no diagrama ampliado (tela cheia): o canvas tem muito mais altura
  // disponível ali, sem esse override o painel ficava raso demais perto do espaço real que sobra
  // até a pilha de controles (zoom in/out etc.) no canto inferior direito — valor aproximado,
  // com folga pra não encostar nos controles; o canvas tem overflow hidden como rede de segurança
  inspectorBoxExpanded: {
    maxHeight: "calc(100vh - 260px)",
  },
  inspectorHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 32,
  },
  inspectorTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  // Limita o campo de observações e mantém a rolagem dentro dele
  observationsField: {
    "& .MuiOutlinedInput-root": {
      maxHeight: 350,
      alignItems: "flex-start",
    },
    "& .MuiInputBase-inputMultiline": {
      maxHeight: 310,
      overflowY: "auto",
    },
  },
  anexosDivider: {
    my: 0.5,
  },
  nodeMenu: {
    maxHeight: "min(480px, calc(100vh - 32px))",
  },
  nodeMenuContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 220,
    p: 1,
  },
  deleteButton: {
    justifyContent: "flex-start",
  },
  // Miniatura do ícone customizado ao lado do label, dentro do Autocomplete de tipo
  customTypeOptionAvatar: {
    width: 20,
    height: 20,
    mr: 1,
  },
  // Ícone dos tipos fixos (não personalizados) no Autocomplete de tipo — mesmo espaço/alinhamento
  // do avatar acima, pra todos os tipos seguirem o mesmo padrão visual (não só os personalizados)
  autocompleteOptionIcon: {
    fontSize: 20,
    mr: 1,
    color: theme.palette.text.secondary,
  },
  // Lista do Autocomplete com altura máxima para evitar transbordamento fora da tela
  autocompleteListbox: {
    maxHeight: "min(320px, calc(100vh - 200px))",
    overflowY: "auto",
  },
  // Item da lista do Autocomplete com alinhamento para avatar e label
  autocompleteOption: {
    display: "flex",
    alignItems: "center",
  },
});

export default styles;
